import styled from 'styled-components';

const PageContent = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  overflow: auto;
`;

export default PageContent;
